import { AttachedPropertyValue, View } from "binder"
import { FormBuilderElement } from "src/formBuilder/structure/element";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { GridViewModel } from "uicomponents";
import { GridLocationDecoratorViewModel } from "./gridLocationDecorator-viewModel"

export class GridLocationDecoratorView extends View<GridLocationDecoratorViewModel>{
    GetViewUniqueId(): string {
        return "V-EDC9C968-FCE6-4C1E-80B8-3FEBAC76522B"
    }
    loadHtml(): string {
        let element = require('./gridLocationDecorator.html').default;
        let style = require('./gridLocationDecorator.less');
        return element;
    }
    constructor() {
       super();
    }

    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;
    public set GridAttachedColumn(v: number) { 
        this._GridAttachedColumn = getAsNumber(v,true);
        this.updatePosition();
    } public get GridAttachedColumn(): number { return this._GridAttachedColumn;} private _GridAttachedColumn: number;
    public set GridAttachedRow(v: number) { 
        this._GridAttachedRow = getAsNumber(v,true);
        this.updatePosition();
    } public get GridAttachedRow(): number { return this._GridAttachedRow;} private _GridAttachedRow: number;
    public set GridAttahedColumnSpan(v: number) { this
        this._GridAttahedColumnSpan = getAsNumber(v,true);
        this.updatePosition();
    } public get GridAttahedColumnSpan(): number { return this._GridAttahedColumnSpan;} private _GridAttahedColumnSpan: number;
    public set GridAttachedRowSpan(v: number) { this
        this._GridAttachedRowSpan = getAsNumber(v,true);
        this.updatePosition();
    } public get GridAttachedRowSpan(): number { return this._GridAttachedRowSpan;} private _GridAttachedRowSpan: number;
    private parentGrid : GridViewModel;
    override onRenderCompleted(){
        setTimeout(()=>{
            this.parentGrid = (<any>this.firstlevelElement.parentNode).binderRelatedView.dataContext;
            this.updatePosition();
        },1000);
    }

    
    private updatePosition(){
        if(this.parentGrid){
            this.parentGrid.column = new AttachedPropertyValue(this.firstlevelElement,this.GridAttachedColumn ?? "1");
            this.parentGrid.columnspan = new AttachedPropertyValue(this.firstlevelElement,this.GridAttahedColumnSpan ?? "1");
            this.parentGrid.row = new AttachedPropertyValue(this.firstlevelElement,this.GridAttachedRow ?? "1");
            this.parentGrid.rowspan = new AttachedPropertyValue(this.firstlevelElement,this.GridAttachedRowSpan ?? "1");
        }
    }
}
